import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
const sizeClasses = {
    sm: 'h-3.5 w-3.5 border-2',
    md: 'h-5 w-5 border-2',
    lg: 'h-8 w-8 border-[3px]',
};
const variantClasses = {
    default: 'text-ax-text-secondary',
    aurora: 'text-ax-aurora',
    plasma: 'text-ax-plasma',
};
export function Spinner({ size = 'md', variant = 'default', label = 'Carregando', className, }) {
    return (_jsx("span", { role: "status", "aria-label": label, className: cn('inline-block animate-spin rounded-full border-current border-r-transparent', sizeClasses[size], variantClasses[variant], className) }));
}
//# sourceMappingURL=Spinner.js.map